module.exports = __webpack_public_path__ + "img/finance.d8ffa58c.svg";